
import { BasicUserData } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { GamePropertiesVO } from "../../gamevo/GamePropertiesVO";
import { SitnGoConfigVO } from "../../gamevo/SitnGoConfigVO";
import { TableListConfigVO } from "../../gamevo/TableListConfigVO";
import { TitlesVO } from "../../gamevo/TitlesVO";
import { TournamentConfigVO } from "../../gamevo/TournamentConfigVO";
import { Poker2Model } from "../Poker2Model";

export class Poker2UserData extends BasicUserData {
    // @ts-ignore // constructor hack
    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }
    public tableListVConfigVO: TableListConfigVO;
    public sitnGoListConfigVO: SitnGoConfigVO;
    public tournamentConfigVO: TournamentConfigVO;
    public gamePropertiesVO: GamePropertiesVO;
    public firstLogin: boolean = false;
    /** Indicates if user has registered in this session. Needed for AB-Test conversion sending. **/
    public registeredInThisSession: boolean = false;
    public isModerator: boolean = false;
    public emailVerified: boolean = false;
    public allowMail: boolean = true;
    public guestName: string = "";
    public blockDialogs: boolean = false;

    private _userCash: number = NaN;
    private _userGold: number = NaN;
    private _userXP: number = 0;
    private _lastUserXP: number = 0;
    private _gainedXP: number = NaN;
    private _userXPcurrentLevel: number = NaN;
    private _userXPtoNextLevel: number = NaN;
    private _titles: any[];
    private _tutorialDone: boolean = false;
    private _tutorialCase: number = 0;

    /*
    *		GET_PLAYER_IDENTITY
    */
    public parse_GPI(paramObject: any): void {
        if (!paramObject)
            return;
        this._userXP = 0;
        this.userID = paramObject.uid;
        this.playerID = paramObject.pid;
        this.userName = paramObject.name;
        this.isModerator = paramObject.isMod;
        this.email = paramObject.email;
        this.emailVerified = paramObject.emailVerified;

        this.controller.dispatchEvent(new Poker2UserEvent("changeUserdata"));
    }

    /*
    *		GET_CURRENCY
    */
    public parse_GCU(paramObject: any): void {
        if (!paramObject)
            return;
        this._userCash = paramObject.cur1;
        this._userGold = paramObject.cur2;
        this.controller.dispatchEvent(new Poker2UserEvent("changeUserCurrency"));
    }

    /*
    *		GET_XP
    */
    public parse_GXP(paramObject: any): void {
        if (!paramObject)
            return;

        if (this._userXP > 0) {
            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_XP);
        }
        this._userXP = paramObject.xp;
        this.userLevel = int(paramObject.level);

        this._userXPcurrentLevel = paramObject.xpCLvl;
        this._userXPtoNextLevel = paramObject.xpNLvl;

        if (this._lastUserXP > 0) {
            this._gainedXP = this._userXP - this._lastUserXP;
        }
        else {
            // first xp gain
            this._gainedXP = this._userXP;
        }

        this._lastUserXP = this._userXP;

        this.controller.dispatchEvent(new Poker2UserEvent("changeUserXP"));
    }

    public parse_GPC(paramObject: any): void {
        if (!paramObject)
            return;
        this.tableListVConfigVO = new TableListConfigVO();
        this.tableListVConfigVO.fOnly = paramObject.fOnly;
        this.tableListVConfigVO.help = paramObject.help;
        this.tableListVConfigVO.ignFull = paramObject.ignFull;
        this.tableListVConfigVO.input = int(paramObject.input);
        this.tableListVConfigVO.sort = int(paramObject.sort);
        this.tableListVConfigVO.tabletype = int(paramObject.tabletype);

        //TODO Input Config sitngo und tournaments
        this.sitnGoListConfigVO = new SitnGoConfigVO();
        this.tournamentConfigVO = new TournamentConfigVO();

        this.gamePropertiesVO = new GamePropertiesVO();
        this.gamePropertiesVO.showTooltip = int(paramObject.showTT);
        this.gamePropertiesVO.ignoreBuddyRequest = int(paramObject.ignoreBuddy);
        this.gamePropertiesVO.playSound = int(paramObject.playSound);
        this.gamePropertiesVO.isSpec = int(paramObject.isSpec);

        if (Poker2Model.userData.gamePropertiesVO.playSound)
            this.controller.soundController.unMuteAll();
        else
            this.controller.soundController.muteAll();

        this.controller.dispatchEvent(new Poker2UserEvent("changeUserLobbyConfig"));
    }

    public get jsonTableConfig(): string {
        var paramObject: any = new Object();
        paramObject.fOnly = this.tableListVConfigVO.fOnly;
        paramObject.help = this.tableListVConfigVO.help;
        paramObject.ignFull = this.tableListVConfigVO.ignFull;
        paramObject.sBlind = this.tableListVConfigVO.input;
        paramObject.sort = this.tableListVConfigVO.sort;
        paramObject.down = this.tableListVConfigVO.down;
        paramObject.up = this.tableListVConfigVO.up;
        return JSON.stringify(paramObject);
    }

    public changeUserMoney(cash: number, gold: number): void {
        this._userCash += cash;
        this._userGold += gold;
        this.controller.dispatchEvent(new Poker2UserEvent("changeUserdata"));
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    public get userCash(): number {
        return this._userCash;
    }

    public get userGold(): number {
        return this._userGold;
    }

    public get gainedXP(): number {
        return this._gainedXP;
    }

    public set gainedXP(value: number) {
        this._gainedXP = value;
    }

    public get lastUserXP(): number {
        return this._lastUserXP;
    }

    public get userXP(): number {
        return this._userXP;
    }

    public get userXPcurrentLevel(): number {
        return this._userXPcurrentLevel;
    }

    public get userXPtoNextLevel(): number {
        return this._userXPtoNextLevel;
    }

    public get userXPcurrentLevelRange(): number {
        return this.userXPtoNextLevel - this.userXPcurrentLevel;
    }

    public get xpPercentToNextLevel(): number {
        return 100 * (this.userXP - this.userXPcurrentLevel) / (this.userXPtoNextLevel - this.userXPcurrentLevel);
    }

    public buildTitles(voList: Map<any, any>): void {
        this.titles = new Array();

        if (voList != null) {
            for (let entryList of Array.from(voList.values())) {
                var element: any = entryList;
                if (element === undefined) { continue; }

                if (instanceOfClass(element, "TitlesVO"))
                    this.titles.push(element);
            }
        }
    }

    public generateTitle(level: number): string {
        var temp: TitlesVO = this.titles[0];

        if (this.titles != null) {
            for (let entryList of this.titles) {
                var element: any = entryList;
                if (element === undefined) continue;

                if (element.level < level && temp.level < element.level)
                    temp = element;
            }
        }
        return temp.name;
    }

    public get titles(): any[] {
        return this._titles;
    }

    public set titles(value: any[]) {
        this._titles = value;
    }

    public get userLevel(): number {
        return this._userLevel;
    }

    public set userLevel(value: number) {
        this._userLevel = value;
    }

    public get tutorialDone(): boolean {
        return this._tutorialDone;
    }

    public set tutorialDone(value: boolean) {
        this._tutorialDone = value;
    }

    public get tutorialCase(): number {
        return this._tutorialCase;
    }

    public set tutorialCase(value: number) {
        this._tutorialCase = value;
    }

}

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
